import Konva from 'konva';

import { UNIFIED_VIEWER_NODE_TYPE_KEY, UnifiedViewerNodeType } from '../types';

const isContainerNode = (node: Konva.Node): boolean =>
  node.attrs[UNIFIED_VIEWER_NODE_TYPE_KEY] ===
  UnifiedViewerNodeType.CONTAINER_GROUP;

export default isContainerNode;
